// extracted by mini-css-extract-plugin
export default {"cardSubItemDetails":"cardSubItemDetails__NWNhZ","withEnhancedPaper":"withEnhancedPaper__MzQ0M"};